import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import { useTranslation } from 'react-i18next';
const TotalRefund = ({ className, price }) => {
    const { t } = useTranslation('Refund');
    const { TotalRefund: css } = useTheme('PriceDetails');
    return React.createElement(PriceItem, { className: cn(css.root, className), name: `${t('Refund amount')}:`, price: price });
};
export default TotalRefund;
